const TYPESENSE_CLOUD_HOST = "8iq4spr5t63o1vlgp.a1.typesense.net";
const TYPESENSE_PRIMARY_HOST = "search.flux.ai";

interface TypesenseSearchCredentialResponse {
    readonly scopedSearchKey: string;
    readonly cluster?: string;
}

export interface TypesenseAuthResponse extends TypesenseSearchCredentialResponse {
    readonly parts?: TypesenseSearchCredentialResponse;
}

export interface TypesenseSearchCredential {
    readonly apiKey: string;
    readonly host: string;
}

export interface TypesenseSearchCredentials {
    readonly projects: TypesenseSearchCredential;
    readonly parts: TypesenseSearchCredential;
}

export function selectTypesenseSearchValue<T>(
    values: {readonly projects: T; readonly parts: T},
    searchIndex: string | undefined,
): T {
    return searchIndex === "components" ? values.parts : values.projects;
}

function credential(response: TypesenseSearchCredentialResponse): TypesenseSearchCredential {
    return {
        apiKey: response.scopedSearchKey,
        host: response.cluster === "primary" ? TYPESENSE_PRIMARY_HOST : TYPESENSE_CLOUD_HOST,
    };
}

export function getTypesenseSearchCluster(credential: TypesenseSearchCredential): "cloud" | "internal" {
    return credential.host === TYPESENSE_PRIMARY_HOST ? "internal" : "cloud";
}

export function resolveTypesenseSearchCredentials(response: TypesenseAuthResponse): TypesenseSearchCredentials {
    const projects = credential(response);
    return {
        projects,
        parts: response.parts ? credential(response.parts) : projects,
    };
}
